import { createSlice } from '@reduxjs/toolkit'

const noAddingSeatsSlice = createSlice({
  name: 'noAddingSeats',
  initialState: {
    noAddingSeatsModalVisible: false
  },
  reducers: {
    closeNoAddingSeatsModal: (state) => {
      state.noAddingSeatsModalVisible = false
    },
    showNoAddingSeatsModal: (state) => {
      state.noAddingSeatsModalVisible = true
    }
  }
})

export const {
  reducer,
  actions: {
    closeNoAddingSeatsModal,
    showNoAddingSeatsModal
  }
} = noAddingSeatsSlice
